import { Typography, type TypographyProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export type MessageProps = PropsWithChildren<TypographyProps>;

export const Message: FC<MessageProps> = ({ children, ...props }) => (
  <Typography variant="body1" color="text.secondary" {...props}>
    {children}
  </Typography>
);
